import ApplicationController from 'javascript/controllers/application_controller';
import { parsePositiveIntOr } from 'javascript/utils/utils';

export default class extends ApplicationController {
  static targets = ['input', 'incrementButton', 'decrementButton'];

  connect() {
    this.init();
  }

  init() {
    this.inputTarget.value = this.initial;
    this.showHideButtons();
  }

  broadcastChange() {
    const event = new CustomEvent('stepperInputChanged', {
      bubbles: true,
      detail: {
        value: this.inputTarget.value,
      },
    });
    this.element.dispatchEvent(event);
  }

  get max() {
    return parseInt(this.data.get('max'));
  }

  get min() {
    return parseInt(this.data.get('min'));
  }

  get initial() {
    return parseInt(this.data.get('initial'));
  }

  get step() {
    return parsePositiveIntOr(this.data.get('step'), 1);
  }

  incrementButtonClicked(e) {
    e.preventDefault();
    this.incrementQuantity();
    this.valueChanged();
  }

  decrementButtonClicked(e) {
    e.preventDefault();
    this.decrementQuantity();
    this.valueChanged();
  }

  valueChanged() {
    this.showHideButtons();
    this.broadcastChange();
    this.inputTarget.dispatchEvent(new Event('change'));
  }

  incrementQuantity() {
    const next = this.quantity + this.step;
    this.inputTarget.value = next > this.max ? this.max : next;
  }

  decrementQuantity() {
    const next = this.quantity - this.step;
    this.inputTarget.value = next < this.min ? this.min : next;
  }

  showHideButtons() {
    const inputValue = parseInt(this.inputTarget.value);
    if (inputValue - this.step < this.min) {
      this.disableButton(this.decrementButtonTarget);
    } else {
      this.enableButton(this.decrementButtonTarget);
    }
    if (inputValue + this.step > this.max) {
      this.disableButton(this.incrementButtonTarget);
    } else {
      this.enableButton(this.incrementButtonTarget);
    }
  }

  disableButton(button) {
    button.setAttribute('disabled', true);
  }

  enableButton(button) {
    button.removeAttribute('disabled');
  }

  get quantity() {
    return parseInt(this.inputTarget.value);
  }
}
